import { useEffect, useMemo, useState } from "react";
import { useLang } from "../../context/LanguageContext";
import {
  PRODUCT_STATUS,
  getProductUi,
  getVisibleProducts,
} from "../../data/products";
import ProductCard from "./ProductCard";
import { ConvocoreCallout } from "./ProductCallouts";
import "./Products.css";

const FILTERS = ["all", "templates", "automation", "software", "coming-soon"];

export default function ProductsCatalog() {
  const { lang } = useLang();
  const ui = getProductUi(lang);
  const products = getVisibleProducts();
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    document.title = `${ui.catalogTitle} | FIKAMI LLC`;
  }, [ui.catalogTitle]);

  const availableFilters = useMemo(
    () =>
      FILTERS.filter((key) => {
        if (key === "all") return true;
        if (key === "coming-soon") {
          return products.some((product) => product.status === PRODUCT_STATUS.COMING_SOON);
        }
        return products.some((product) => product.category === key);
      }),
    [products],
  );

  const filteredProducts = products.filter((product) => {
    if (filter === "all") return true;
    if (filter === "coming-soon") return product.status === PRODUCT_STATUS.COMING_SOON;
    return product.category === filter;
  });

  return (
    <main className="digital-products-page">
      <section className="digital-products-hero">
        <div className="digital-products-container">
          <span className="digital-products-eyebrow">{ui.eyebrow}</span>
          <h1>{ui.catalogTitle}</h1>
          <p>{ui.catalogSubtitle}</p>
        </div>
      </section>

      <section className="digital-products-catalog">
        <div className="digital-products-container">
          <div className="digital-products-filters" aria-label="Product filters">
            {availableFilters.map((key) => (
              <button
                key={key}
                type="button"
                className={filter === key ? "is-active" : ""}
                onClick={() => setFilter(key)}
              >
                {ui.filters[key]}
              </button>
            ))}
          </div>

          {filteredProducts.length > 0 ? (
            <div className="digital-products-grid">
              {filteredProducts.map((product) => (
                <ProductCard key={product.id} product={product} lang={lang} ui={ui} />
              ))}
            </div>
          ) : (
            <p className="digital-products-empty">{ui.empty}</p>
          )}

          <ConvocoreCallout ui={ui} />
        </div>
      </section>
    </main>
  );
}
